module.exports = __webpack_public_path__ + "static/img/cct_logo.f1387688.png";